import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { locations } from '../data/locations';

const createPhotoIcon = (imageUrl: string) =>
  L.divIcon({
    className: 'photo-marker',
    html: `<div class="photo-marker-inner" style="background-image:url('${imageUrl}')"></div>`,
    iconSize: [30, 30],
    iconAnchor: [15, 15],
    popupAnchor: [0, -18],
  });

const Map: React.FC = () => {
  return (
    <div style={{ width: '100%', height: '60vh', margin: 'auto' }}>
      <MapContainer
        center={[10, 105]}
        zoom={4}
        zoomSnap={0.25}
        zoomDelta={0.5}
        bounceAtZoomLimits={false}
        style={{ width: '100%', height: '100%' }}
      >
        <TileLayer
          url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
          subdomains="abcd"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
        />
        {locations.map((loc) => (
          <Marker key={loc.slug} position={loc.position} icon={createPhotoIcon(loc.image)}>
            <Popup className="dark-glass-popup">
              <div style={{ textAlign: 'center' }}>
                <img
                  src={loc.image}
                  alt={loc.name}
                  style={{
                    width: '72px',
                    height: '72px',
                    objectFit: 'cover',
                    borderRadius: '10px',
                    marginBottom: '6px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                  }}
                />
                <h3 style={{ margin: '4px 0' }}>{loc.name}</h3>
                <p style={{ margin: '0 0 4px' }}>{loc.description}</p>
                <p style={{ margin: '0 0 8px', fontSize: '13px', opacity: 0.7 }}>
                  {loc.dateRange}
                </p>
                <a
                  href={`/location/${loc.slug}`}
                  style={{
                    display: 'inline-block',
                    padding: '6px 12px',
                    background: 'linear-gradient(90deg, #7ab7ff, #b77dff)',
                    color: '#0b1220',
                    fontWeight: 600,
                    borderRadius: '4px',
                    textDecoration: 'none',
                  }}
                >
                  View Gallery
                </a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default Map;
